import React from 'react';
import { DvrOutlined, InfoOutlined, OpenInNewOutlined } from '@mui/icons-material';
import DashboardCard, { CardHeader } from '../DashboardCard/DashboardCard';
import configs from '../../../../config.json';

export default function OnboardingCard({ portalUrl = configs.REACT_APP_TIFO_URL }) {
  return (
    <DashboardCard>
      <CardHeader icon={<DvrOutlined />} title="Onboarding" />
      <div className="px-5 pb-5 flex flex-col gap-3">
        <div className="flex gap-3 bg-[#E6F4F8] rounded-[10px] p-4 border border-[#C5E4EE]">
          <InfoOutlined sx={{ fontSize: 17, color: '#0094B3', flexShrink: 0, marginTop: '1px' }} />
          <p className="text-[14px] text-[#1A2B35] leading-relaxed m-0">
            Your onboarding runs in a secure guided portal. Pick up exactly where
            you left off — progress saves automatically.
          </p>
        </div>
        <a
          href={portalUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 w-full py-3 bg-[#0094B3] text-white text-[15px] font-semibold rounded-[8px] no-underline hover:bg-[#0081A0] transition-colors duration-150"
        >
          Open Onboarding Portal
          <OpenInNewOutlined sx={{ fontSize: 16 }} />
        </a>
      </div>
    </DashboardCard>
  );
}